import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, permissionLevel } = useContext(AuthContext);

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (
    requiredPermission &&
    Array.isArray(requiredPermission) &&
    !requiredPermission.includes(permissionLevel)
  ) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};
